import React from 'react'
import { useTranslation } from 'react-i18next'

const ChatHeaderSection = ({ visibleChats, handleVisibleChats }) => {
    const { t } = useTranslation()
    return (
        <div className="chat-header-section">
            <button className={`chat-header-btn ${visibleChats ? 'chat-header-button-selected' : ''}`} onClick={() => handleVisibleChats(true)}>
                <div className={`chat-header-button-text ${visibleChats ? 'chat-header-button-text-selected' : ''}`}>{t('Visible chats')}</div>
            </button>
            <button className={`chat-header-btn ${!visibleChats ? 'chat-header-button-selected' : ''} `} onClick={() => handleVisibleChats(false)}>
                <div className={`chat-header-button-text ${!visibleChats ? 'chat-header-button-text-selected' : ''}`}>{t('Anonymous chats')}</div>
            </button>
        </div>
    )
}

export default ChatHeaderSection
